<template>
<div class="warp">
    <div id="container"></div>
    <Toolbar @selectMenu="selectMenu" />
    <TilesTransform :tileset="tileset" v-if="flagObj.isTransform"/>
    <TilesCutting ref="tilesCutting" :tileset="tileset" v-if="flagObj.isCutting"/>
    <Ranging ref="ranging" v-if="flagObj.isRanging"/>
</div>
    
</template>

<script>
import * as Cesium from "cesium/Cesium";
import * as widgets from "cesium/Widgets/widgets.css";

window.viewer = null
window.Cesium = Cesium
window.earth = null
window.convenient = null
import InitCesium from './viewer/js/initCesium'
import Convenient from './viewer/js/convenient'
import Tiles from './viewer/js/model'
import { tilesUrl } from '../utils/config'
const Toolbar = ()=> import('./editor/Toolbar.vue')
const TilesTransform = ()=> import('./editor/TilesTransform.vue')
const TilesCutting = ()=> import('./editor/TilesCutting.vue')
const Ranging = ()=> import('./editor/Ranging.vue')

import json1 from '../../public/room/scenetree.json'
export default {
    components:{
        Toolbar, TilesTransform, TilesCutting, Ranging
    },
    data(){
        return {
            tileset:null,
            tile:new Tiles(),
            flagObj:{
                isTransform:false,
                isCutting:false,
                isRanging:false
            },
            json: require('../../public/room/scenetree.json'),
            json1
            
        }
    },
    mounted(){
        this.init()
        
        
    },
    methods:{
        init(){
            Cesium.Ion.defaultAccessToken =
                'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyYjZjYWUyZi00YWRkLTRjMjUtYmNmNC0xMWViMjgxYjI4MDgiLCJpZCI6NjYxMjEsImlhdCI6MTYzMDY1MzcxN30.GTEf3cn_2IGsuOoqIuznPJ_D8py8PUt97UG7THjymnc';
            earth = new InitCesium('container', {
                skyAtmosphere: false,
                shouldAnimate : true,
                terrainProvider: Cesium.createWorldTerrain()
            });

            viewer.imageryLayers.addImageryProvider(
                new Cesium.WebMapTileServiceImageryProvider({   
                    url: 'http://t0.tianditu.gov.cn/cia_w/wmts?tk=65f301fcf76d9c4af0682eee02b7a7b9',
                    layer:'cia',
                    style:'default',
                    tileMatrixSetID:'w',
                    format:'tiles',
                    maximumLevel: 18
                })
            );
            viewer.scene.globe.depthTestAgainstTerrain = true;
            convenient = new Convenient({viewer})

            this.addThreeTiles()

            // this.degrees()
            
        },
        addThreeTiles(){
            let _this = this
            let tileset = viewer.scene.primitives.add(new Cesium.Cesium3DTileset({
                url:tilesUrl +'/lutaidasha/tileset.json',
                maximumScreenSpaceError: 1,
                maximumMemoryUsage: 2048,
            }))
            tileset.readyPromise.then(function(tileset){
                let boundingSphere = tileset.boundingSphere
                let cartographic = Cesium.Cartographic.fromCartesian(boundingSphere.center)
                let surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude,0)
                let offset = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, 4)
                let translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3())
                tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation)
            })
            this.tileset = tileset
            viewer.zoomTo(tileset)
        },
        selectMenu(menu){
            let _this = this
            console.log(menu);
            _this.resetFlag()
            switch(menu.bar){
                case '裁切':
                    _this.flagObj.isCutting = menu.falg
                    break;
                case '旋转':
                    _this.flagObj.isTransform = menu.falg
                    break;
                case '测距':
                    _this.flagObj.isRanging = menu.falg
                    break;
                case '主视角':
                    convenient.fly({
                        x: -2331090.100839201,
                        y: 4656628.2587722065,
                        z: 3670610.0484654326,
                        heading:6.272933419640759,
                        pitch:-0.27094197093883965,
                        roll:6.283184446243114
                    })
                    break;
            }
            
        },
        resetFlag(){
            if(this.flagObj.isCutting){
                this.$refs.tilesCutting.removeClip()
            }
            if(this.flagObj.isRanging){
                this.$refs.ranging.remove()
            }
            for(let key in this.flagObj){
                this.flagObj[key] = false
            }
            
        },
        degrees(){
            console.log('???????????');
            let entityArr = []
            for(let i = -180;i<180;i++){
                for(let j = -90;j<90;j++){
                    entityArr.push(
                        viewer.entities.add({
                            polygon:{
                                hierarchy:Cesium.Cartesian3.fromDegreesArray([
                                    i, -j, 
                                    i , -j - 1,
                                    i + 1, - j - 1,
                                    i + 1, - j 
                                ]),
                                material:Cesium.Color.fromCssColorString('#00000001'),
                                height:0,
                                outline:true,
                                outlineWidth:1,
                                outlineColor:Cesium.Color.WHITE.withAlpha(0.1)
                            }
                        })
                    )
                }
            }
            let view = Cesium.Cartesian3.fromDegrees(-180, -90, 0)
            convenient.fly({
                x:view.x,
                y:view.y,
                z:view.z
            })
        },
        handler(){
            let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas)
            handler.setInputAction((moment)=>{
                let pick = viewer.scene.pick(moment.position)
                console.log(pick);
                let propertyNames = pick.getPropertyNames()
                console.log(propertyNames);
                    let name = pick.getProperty(propertyNames.find(item =>item == 'id'))
                    console.log(name);
            }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
        }

    }
}
</script>

<style scoped lang="less">
.warp{
    position: relative;
}
#container{
    width: 100vw;
    height: 100vh;
    z-index: 0;
}
#win{
    position: absolute;
    top: 0;
    left: 1vw;
    width: 5vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    .btn{
        height: 3vh;
        line-height: 3vh;
        text-align: left;
        border: 1px solid gold;
    }
}
</style>